import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs';
import { Store } from '@ngrx/store';
import { ApplicationState } from '@store/application-store';
import { SupplierDetails } from '@suppliers/models/supplier-details';
import { selectSupplierDetailsState } from '@suppliers/selectors/supplier-details.selectors';
import * as supplierDetailsActions from '@suppliers/actions/supplier-details.actions';


@Injectable({
  providedIn: 'root'
})
export class SupplierDetailsService {

  constructor(
    private readonly store: Store<ApplicationState>,
  ) {
    this.supplierDetails = this.store.select(selectSupplierDetailsState)
      .pipe(
        filter(state => !state.loading && state.supplierDetails != undefined),
        map(state => state.supplierDetails)
      );
  }

  readonly supplierDetails: Observable<SupplierDetails>;

  load(supplierRef: number) {
    this.store.dispatch(new supplierDetailsActions.Get(supplierRef));
  }

}

